import { Component, ViewChild, ChangeDetectorRef } from "@angular/core";
import { ListWindow, PageService, TabComponent } from "@xo/client-common";
import { Type9SpecialsTable } from "./type9Specials.table";

@Component({
  selector: "spec-app-type9-specials-list-window",
  templateUrl: "./type9Specials.list.html",
  styleUrls: ["./type9Specials.list.scss"]
})
export class Type9SpecialsListWindowComponent extends ListWindow {

  @ViewChild("table", { static: false }) table: Type9SpecialsTable;

  clickHandler: Function;

  constructor(changeDetectorRef: ChangeDetectorRef, private tab: TabComponent, public pageService: PageService) {
    super(changeDetectorRef);
  }

  init(filters?) {
    this.clickHandler = this.pageService.createOpenObject(
      "SpecApp/Type9SpecialsPage",
      this.tab.system,
      (object) => `Type9Specials at ID:${object ? object.id : null}`,
      () => ({})
    );
    super.init(filters, this.table);
  }

  reload() {
    console.log("Type9SpecialsList reload");
    super.reload();
    this.table.refreshList();
  }
}
